import {NavigationBehaviorOptions, Router} from '@angular/router';
import {NavigationTrigger} from '../angular/angular-utils';

export class NavigationUtils {

  // Set ignoreOnNavigationFailed to true when the navigation promise is expected to resolve to false through no fault of
  // its own - e.g. the reactive page self-redirects on entry to apply default query params, or another navigation
  // legitimately supersedes this one. Leave it false to surface genuine failures (guard rejections, unmatched routes).
  public static onNavigated(navigateResult: Promise<boolean>, ignoreOnNavigationFailed = false) {
    navigateResult.then(navigated => {
      if (!ignoreOnNavigationFailed && !navigated) {
        throw new Error('Navigation did not happen as expected.');
      }
    });
  }

  public static getNgNavigationState(router: Router): NavigationBehaviorOptions['state'] {
    return router.getCurrentNavigation()?.extras?.state ?? null;
  }

  public static getImperativeNgNavigationState(router: Router): NavigationBehaviorOptions['state'] {
    const navigation = router.getCurrentNavigation();
    return (navigation?.trigger === NavigationTrigger.IMPERATIVE ? (navigation.extras?.state ?? null) : null);
  }
}
